<template>
  <div :class="'qc-login-way-tab qc-tab-style-' + (props.loginWays.length)">
    <div
      v-for="(item, index) in loginWays"
      :key="index"
      :class="'qc-tab-item ' + (props.curLoginWay === item.value ? 'active' : '')"
      @click="toggleTab(item.value)">
      {{ item.name }}
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, computed } from 'vue';
import { LOGIN_TYPE } from '../../core/constants/index';
import type { TabProps } from '../types';

const props = withDefaults(defineProps<TabProps>(), {});
const tabDictionaries = { [LOGIN_TYPE.ACCOUNT]: "密码登录", [LOGIN_TYPE.PHONE]: "短信登录", channel: "渠道登录" };

const loginWays = computed(() => {
  return props.loginWays.map((item: number) => {
    return {
      name: tabDictionaries[item as keyof typeof tabDictionaries],
      value: item,
    };
  });
});

const toggleTab = (item: number) => {
  props.toggleLoginWay(item);
};

const activeTab = ref(0);
</script>